"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedNamespace = void 0;
const model_1 = require("../../data/model");
const store_1 = require("../../storage/store");
const backends_1 = require("../../storage/backends");
const Mesh_1 = require("../service/Mesh");
class SharedNamespace {
    constructor(spaceId, localPeer, config, resources) {
        this.spaceId = spaceId;
        this.localPeer = localPeer;
        if ((resources === null || resources === void 0 ? void 0 : resources.store) !== undefined) {
            this.store = resources.store;
        }
        else {
            this.store = new store_1.Store(new backends_1.IdbBackend('group-shared-space-' + spaceId + '-' + localPeer.identityHash));
        }
        if ((resources === null || resources === void 0 ? void 0 : resources.mesh) !== undefined) {
            this.mesh = resources.mesh;
        }
        else {
            this.mesh = new Mesh_1.Mesh();
        }
        if ((config === null || config === void 0 ? void 0 : config.syncDependencies) !== undefined) {
            this.syncDependencies = config.syncDependencies;
        }
        else {
            this.syncDependencies = true;
        }
        if ((config === null || config === void 0 ? void 0 : config.peerGroupAgentConfig) !== undefined) {
            this.peerGroupAgentConfig = config === null || config === void 0 ? void 0 : config.peerGroupAgentConfig;
        }
        else {
            this.peerGroupAgentConfig = {}; // empty config (defaults)
        }
        this.objects = new Map();
        this.definedKeys = new Map();
        this.started = false;
    }
    connect() {
        if (this.peerSource === undefined) {
            throw new Error("Cannot connect before setting a peerSource");
        }
        this.mesh.joinPeerGroup({ id: this.spaceId, localPeer: this.localPeer, peerSource: this.peerSource }, this.peerGroupAgentConfig);
    }
    setPeerSource(peerSource) {
        if (this.started) {
            throw new Error("Can't change peer source after space has started.");
        }
        this.peerSource = peerSource;
    }
    getPeerSource() {
        return this.peerSource;
    }
    getMesh() {
        return this.mesh;
    }
    getStore() {
        return this.store;
    }
    async attach(key, mut) {
        mut.setId(model_1.HashedObject.generateIdForPath(this.spaceId, key));
        this.definedKeys.set(key, mut);
        await this.store.save(mut);
        this.addObject(mut);
    }
    get(key) {
        return this.definedKeys.get(key);
    }
    addObject(mut) {
        let hash = mut.hash();
        if (!this.objects.has(hash)) {
            this.objects.set(mut.hash(), mut);
            this.mesh.syncObjectWithPeerGroup(this.spaceId, mut, Mesh_1.SyncMode.recursive);
        }
    }
}
exports.SharedNamespace = SharedNamespace;
//# sourceMappingURL=SharedNamespace.js.map